export default class SignupRequest {
  name = null;
  email = null;
  password = null;
  confirmPassword = null;
  timeZone = null;

  build () {
    const {
      name,
      email,
      password,
      confirmPassword,
      timeZone,
    } = this;

    return {
      name,
      email,
      password,
      confirmPassword,
      timeZone,
    };
  }
}
